<template>
  <div class="box">
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="3"><p class="label">Last logged in</p></v-col>
          <v-col cols="3"><v-text-field :value="user.lastLogonYmdhms | format('yyyy-MM-dd HH:mm:ss')" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">Password changed at</p></v-col>
          <v-col cols="3"><v-text-field :value="user.pwdChangeYmd | format('yyyy-MM-dd')" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">Lock status</p></v-col>
          <v-col cols="3"><v-text-field :value="user.lockStatus" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">Created by / at</p></v-col>
          <v-col cols="3"><v-text-field :value="user.createdBy" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="3"><v-text-field :value="user.createdYmd | format('yyyy-MM-dd')" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
</style>
